import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouteMatch} from 'react-router-dom';
import {getOneStock, getStockDetail} from '@/redux/stockSlice';
import {getShippingCosts} from '@/api/shippingCosts';

export const useGetStock = (
  setCost: React.Dispatch<React.SetStateAction<{id: number; userId: number}>>
) => {
  const {
    params: {stockId},
  } = useRouteMatch<{stockId: string}>();

  const {data, detail, userId, isCompany, shippingProvider} = useSelector(
    (state) => {
      return {
        userId: state.me.id,
        isCompany: state.me.isCompany,
        shippingProvider: state.me.shippingProvider,
        data: state.stocks.data,
        detail: state.stocks.detail,
      };
    }
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const id = parseInt(stockId, 10);

    dispatch(getOneStock(id));
    dispatch(getStockDetail(id));
  }, [dispatch, stockId]);

  useEffect(() => {
    const fetch = async (userId: number) => {
      try {
        const res: any = await getShippingCosts(userId);
        setCost({
          id: res.data.id,
          userId: res.data.user_id,
        });
      } catch (error: any) {
        console.error(error);
      }
    };
    fetch(userId);
  }, [userId, setCost]);

  return {data, userId, isCompany, shippingProvider, stockId, detail};
};
